"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
require("./MapmakerToolbarDivider.css");
function MapmakerToolbarDivider() {
    return (0, jsx_runtime_1.jsx)("div", { id: "mapmaker-toolbar-divider" });
}
exports.default = MapmakerToolbarDivider;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFwbWFrZXJUb29sYmFyRGl2aWRlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3Byb2plY3Qvc2hhcmVkL3Rvb2xiYXIvTWFwbWFrZXJUb29sYmFyRGl2aWRlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsd0NBQXNDO0FBRXRDLFNBQXdCLHNCQUFzQjtJQUM1QyxPQUFPLGdDQUFLLEVBQUUsRUFBQywwQkFBMEIsR0FBRyxDQUFDO0FBQy9DLENBQUM7QUFGRCx5Q0FFQyJ9